import {ValueEditorLocalizationManager} from './value-editor-localization.manager';
import type {ValueEditorType} from '../types';
import type {ValueEditorTypeMap} from '../types';
import type {ValueEditorLocalizations} from './types';

export class ValueEditorLocalizationManagerProvider {
    public static serviceName = 'valueEditorLocalizationManagerProvider';

    private localizationManagersByType: Map<ValueEditorType, ValueEditorLocalizationManager<ValueEditorLocalizations>> = new Map();

    public registerForType<TYPE extends keyof ValueEditorTypeMap>(type: TYPE, defaultLocalizations: Required<Readonly<ValueEditorTypeMap[TYPE]['localizations']>>): ValueEditorLocalizationManagerProvider {
        this.localizationManagersByType.set(type, new ValueEditorLocalizationManager<ValueEditorTypeMap[TYPE]['localizations']>(defaultLocalizations));
        return this;
    }

    public getManagerForType<TYPE extends keyof ValueEditorTypeMap>(type: TYPE): ValueEditorLocalizationManager<ValueEditorTypeMap[TYPE]['localizations']> {
        if (!this.localizationManagersByType.has(type)) {
            throw new Error(`Unable to resolve localization manager of type: ${type}`);
        }

        return this.localizationManagersByType.get(type) as ValueEditorLocalizationManager<ValueEditorTypeMap[TYPE]['localizations']>;
    }
}